export const parseDateValue = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  
  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? null : parsed;
};

/** Parse YYYY-MM-DD URL param without timezone shift; returns the key or null. */
export const parseVisitDateParam = (value) => {
  if (!value || typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return null;
  const [y, m, d] = trimmed.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  if (
    date.getFullYear() !== y ||
    date.getMonth() !== m - 1 ||
    date.getDate() !== d
  ) {
    return null;
  }
  return trimmed;
};

/** Local calendar date from a YYYY-MM-DD key. */
export const visitDateFromYmdKey = (ymdKey) => {
  const parsed = parseVisitDateParam(ymdKey);
  if (!parsed) return null;
  const [y, m, d] = parsed.split('-').map(Number);
  return new Date(y, m - 1, d);
};

export const getEffectiveVisitDate = (selectedDate, selectedTimeSlot, selectedTickets = []) => {
  const directDate = parseDateValue(selectedDate);
  if (directDate) return directDate;

  const slotDate = parseDateValue(selectedTimeSlot?.startDateTime || selectedTimeSlot?.date);
  if (slotDate) return slotDate;

  const ticketWithDate = selectedTickets.find(ticket => 
    ticket?.selectedDate || ticket?.selectedEventTime?.startDateTime
  );
  if (ticketWithDate) {
    return parseDateValue(ticketWithDate.selectedDate || ticketWithDate.selectedEventTime?.startDateTime);
  }

  return null;
};

export const isToddlerSpecialUpsell = (name = '') => {
  return typeof name === 'string' && name.toLowerCase().includes("toddler special");
};

/** Reptile Day (Animal Park) — visit date from ?date=2026-05-27 booking links. */
export const REPTILE_DAY_VISIT_DATE = '2026-05-27';

/** 1pm, 2pm and 3pm — reptiles are on site until 1pm only. */
const REPTILE_DAY_HIDDEN_SLOT_HOURS = new Set([13, 14, 15]);

export const getTimeSlotHour = (timeSlot) => {
  if (!timeSlot) return null;
  const raw = timeSlot.time ?? timeSlot.label ?? timeSlot;
  if (typeof raw === 'string') {
    const match = raw.trim().match(/^(\d{1,2}):(\d{2})/);
    if (match) return parseInt(match[1], 10);
  }
  const start = timeSlot.startDateTime || timeSlot.startTime;
  if (start) {
    const d = new Date(start);
    if (!isNaN(d.getTime())) return d.getHours();
  }
  return null;
};

export const isReptileDayHiddenTimeSlot = (timeSlot, pinnedVisitDate = REPTILE_DAY_VISIT_DATE) => {
  if (pinnedVisitDate !== REPTILE_DAY_VISIT_DATE) return false;
  const hour = getTimeSlotHour(timeSlot);
  return hour != null && REPTILE_DAY_HIDDEN_SLOT_HOURS.has(hour);
};

export const filterTimeSlotsForPinnedVisit = (slots, pinnedVisitDate) => {
  if (!Array.isArray(slots) || pinnedVisitDate !== REPTILE_DAY_VISIT_DATE) {
    return slots;
  }
  return slots.filter((slot) => !isReptileDayHiddenTimeSlot(slot, pinnedVisitDate));
};

export const isToddlerRestrictedDate = (date) => {
  const dateObj = parseDateValue(date);
  if (!dateObj) return false;

  const month = dateObj.getMonth(); // 0-indexed (0 = January)
  const day = dateObj.getDate();

  if (month === 10) { // November
    return day === 29 || day === 30;
  }

  if (month === 11) { // December
    return [6, 7, 8, 13, 14, 20, 21, 22, 23, 24].includes(day);
  }

  return false;
};

